/* ============================================================
   OPALE — Size Chart JS
   Paste into: Assets > opale-size-chart.js
   Then add before </body> in theme.liquid:
   <script src="{{ 'opale-size-chart.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  /**
   * Toggle the accordion open / closed.
   * Called by: onclick="opaleToggleChart(this)" on the trigger button.
   */
  window.opaleToggleChart = function (triggerBtn) {
    var chart = triggerBtn.closest('.opale-size-chart');
    var panel = chart.querySelector('.opale-size-chart__panel');
    var isOpen = chart.hasAttribute('data-open');

    if (isOpen) {
      chart.removeAttribute('data-open');
      panel.setAttribute('hidden', '');
      triggerBtn.setAttribute('aria-expanded', 'false');
    } else {
      chart.setAttribute('data-open', '');
      panel.removeAttribute('hidden');
      triggerBtn.setAttribute('aria-expanded', 'true');
    }
  };

  /**
   * Switch between cm / in tables.
   * Called by: onclick="opaleSetUnit(this, 'cm')" on toggle buttons.
   */
  window.opaleSetUnit = function (btn, unit) {
    var panel   = btn.closest('.opale-size-chart__panel');
    var toggles = btn.closest('.opale-size-chart__unit-toggle').querySelectorAll('button');
    var cmTables = panel.querySelectorAll('.opale-sc-table[data-unit-cm]');
    var inTables = panel.querySelectorAll('.opale-sc-table[data-unit-in]');

    /* Update active button */
    toggles.forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');

    /* Show / hide tables */
    if (unit === 'cm') {
      cmTables.forEach(function (t) { t.removeAttribute('hidden'); });
      inTables.forEach(function (t) { t.setAttribute('hidden', ''); });
    } else {
      inTables.forEach(function (t) { t.removeAttribute('hidden'); });
      cmTables.forEach(function (t) { t.setAttribute('hidden', ''); });
    }
  };
})();
